import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { jsx as _jsx } from "react/jsx-runtime";
export function ToolbarDropdown(props) {
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({
    animateOnToggle: false,
    arrowSize: "small",
    autoPlacement: "horiz",
    buttonUse: "transparent",
    buttonSize: "small",
    closeOnMenuClick: false,
    marginBlockEnd: "50",
    paddingBlock: "100",
    paddingInline: "100",
    placement: "bottom right",
    use: "unstyled"
  }, props));
}